import React, { useState, useEffect, useRef } from 'react';
import Icons from '../../icons';

const ReopenReasons = (props) => {
    const [selectedValue, setSelectedValue] = useState();
    const [reasonList, setReasonList] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    const prevWrkdReasonList = useRef();

    useEffect(() => {
        if (props.wrkdReasonList !== prevWrkdReasonList.current) {
            setReasonList(props.wrkdReasonList);
            setSelectedValue(props.defaultSelectedValue);
        }
        prevWrkdReasonList.current = props.wrkdReasonList;

        if (props.wrkdReasonList) {
            setSelectedValue(props.defaultSelectedValue);
            const handleClickOutside = (event) => {
                if (ref.current && !ref.current.contains(event.target)) {
                    setIsOpen(false);
                }
            };
            document.addEventListener('mousedown', handleClickOutside);

            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [props.wrkdReasonList, props.defaultSelectedValue]);

    const reasonSelected = (item) => {
        props.selectedValue(item);
        setSelectedValue(item.Reason);
        setIsOpen(false);
    }

    return (
        <div className={props.className}>
            <div className="alignMiddle rowSpaceBetween flexGrow" onClick={() => setIsOpen(!isOpen)}>
                <span>{selectedValue}</span>
                <Icons name="arrow" className="icon arrow mr" />
            </div>
            {
                isOpen && reasonList.length > 0 && (
                    <div ref={ref} className="dropDownMenu openBotttom onClick largex">
                        {
                            reasonList.map((item, index) => (
                                <span key={index} onClick={() => reasonSelected(item)}>
                                    <a className="pointer active">{item.Reason}
                                        {item.Reason === selectedValue && <span className="badges checked selectChecked green"></span>}
                                    </a>
                                </span>
                            ))
                        }
                    </div>
                )
            }
        </div>
    );
};

export default ReopenReasons;
